// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__+wd9j","label":"Login_label__ag7J4","input":"Login_input__xEN53","button":"Login_button__OdYu-","iconEye":"Login_iconEye__xXo5b","logo":"Login_logo__6JrNT"};